import { Logo } from "../../../common"

export function Footer() {
  return (
    <footer className="border-t border-white/5 py-12">
      <div className="mx-auto max-w-7xl px-6 grid md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="landpage-logo mb-2">
            <Logo />
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">
            Treinos com estímulos. Evolução com dados.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-muted-foreground md:justify-center">
          <a href="#top" className="hover:text-primary">Sobre</a>
          <a href="#como-funciona" className="hover:text-primary">Como funciona</a>
          <a href="#funcionalidades" className="hover:text-primary">Funcionalidades</a>
          <a href="#precos" className="hover:text-primary">Preços</a>
          <a href="mailto:contato@kinerfy.com" className="hover:text-primary">Contato</a>
        </nav>

        <div className="flex gap-3 md:justify-end">
          {[
            { label: "Instagram", d: "M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 100 10 5 5 0 000-10zm6.5-.5a1 1 0 100 2 1 1 0 000-2z" },
            { label: "LinkedIn", d: "M4 4h4v16H4zM6 2a2 2 0 110 4 2 2 0 010-4zm6 6h4v2a4 4 0 018 0v10h-4v-8a2 2 0 10-4 0v8h-4z" },
            { label: "X", d: "M3 3h4l5 7 5-7h4l-7 10 7 11h-4l-5-8-5 8H3l7-11z" },
          ].map((s) => (
            <a
              key={s.label}
              href="#"
              aria-label={s.label}
              className="h-10 w-10 rounded-full border border-white/10 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d={s.d} /></svg>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-muted-foreground space-y-1">
        <p>© Copyright {new Date().getFullYear()} - Kinerfy - Todos os direitos reservados</p>
        <p>CNPJ: 45660157000181</p>
        <p>Email: contato@kinerfy.com</p>
      </div>
    </footer>
  )
}
